module.exports = __webpack_public_path__ + "static/media/muneca2.3d9934f3.png";